import { Table, TableHead, TableCell, TableRow, TableBody, Select, MenuItem, Tooltip, Modal, Box, Autocomplete, TextField, Chip } from '@mui/material';
import { LogoGenerator } from '../../../components/LogoGenerator';
import magnifying_glass from '../../../assets/images/magnifying_glass.svg';
// import {  } from '../utils';
import { formatPrice } from '../../../utils/formatPrice';
import { BetPriceDropdown } from '../../../components/BetPrice';
import './RelatedOddsDropdown.css';
import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { OddsHistoryGraph } from './OddsHistoryGraph';
// import up_icon from '../../../assets/images/up_icon.svg';
// import down_icon from '../../../assets/images/arrow_down_icon.svg';
import { TimeRangeSelector } from './TimeRangeSelector';
import './RelatedOddsDropdown.css';
import { UpgradeModal } from '../../../components/UpgradeModal/UpgradeModal';
import { devigOddsProbit } from '../utils';
import { getSportsbookDisplayName, normalizeSportsbookName, shouldPreferSportsbookRow } from '../../../utils/sportsbookAliases';

function sortByPropertyMatch(arr, property, matchArray) {
	return arr.sort((a, b) => {
		const aInArray = matchArray?.includes(a[property]);
		const bInArray = matchArray?.includes(b[property]);

		if (aInArray && !bInArray) return -1; // a should come first
		if (!aInArray && bInArray) return 1; // b should come first
		return 0; // maintain relative order otherwise
	});
}

export function americanToDecimal(oddsStr) {
	const odds = parseFloat(oddsStr);

	if (isNaN(odds)) {
		throw new Error('Invalid odds input');
	}

	if (odds > 0) {
		return (odds / 100 + 1).toFixed(2);
	} else {
		return (100 / Math.abs(odds) + 1).toFixed(2);
	}
}

// Safely pick a price value, with fallbacks for Point Spread entries
function pickPrice(row, primaryKey, isSpread) {
    const val = row?.[primaryKey];
    if (val != null) return val;
    if (!isSpread) return null;
    if (primaryKey?.startsWith('bet_price_over')) {
        return row?.bet_price_over_positive ?? row?.bet_price_over_negative ?? row?.bet_price_over ?? null;
    }
    if (primaryKey?.startsWith('bet_price_under')) {
        return row?.bet_price_under_positive ?? row?.bet_price_under_negative ?? row?.bet_price_under ?? null;
    }
    return null;
}

function sortByNumberMatch(arr, property, matchNumber) {
	return arr.sort((a, b) => {
		const aMatches = a[property] === matchNumber;
		const bMatches = b[property] === matchNumber;

		if (aMatches && !bMatches) return -1; // a should come first
		if (!aMatches && bMatches) return 1; // b should come first
		return 0; // maintain relative order otherwise
	});
}

function decimalToAmerican(decimal) {
	if (decimal == null) return null;
	if (decimal >= 2.0) return Math.round((decimal - 1) * 100);
	if (decimal < 2.0 && decimal > 1) return Math.round(-100 / (decimal - 1));
	return null;
}

function checkIfPricesChanged(mainObj, priceArray, overSide, underSide) {
	try {
		const dumbBook = mainObj.sportsbook_dumb;
		const sharpBook = mainObj.sportsbook_sharp;

		const result = {
			dumbBook,
			sharpBook,
			dumbChanged: { over: null, under: null },
			sharpChanged: { over: null, under: null },
			phrase: '',
		};

		const findBook = (book) => priceArray.find((p) => p.sportsbook === book);

		const dumbEntry = findBook(dumbBook);
		const sharpEntry = findBook(sharpBook);

		const roundedMain = {
			dumbOver: mainObj[`${overSide}_dumb`] != null ? Math.round(mainObj[`${overSide}_dumb`]) : null,
			dumbUnder: mainObj[`${underSide}_dumb`] != null ? Math.round(mainObj[`${underSide}_dumb`]) : null,
			sharpOver: mainObj[`${overSide}_sharp`] != null ? Math.round(mainObj[`${overSide}_sharp`]) : null,
			sharpUnder: mainObj[[`${underSide}_sharp`]] != null ? Math.round(mainObj[`${underSide}_sharp`]) : null,
		};

		if (dumbEntry) {
			const overAm = decimalToAmerican(dumbEntry[overSide]);
			const underAm = decimalToAmerican(dumbEntry[underSide]);
			result.dumbChanged.over = overAm !== roundedMain.dumbOver;
			result.dumbChanged.under = underAm !== roundedMain.dumbUnder;
		}

		if (sharpEntry) {
			const overAm = decimalToAmerican(sharpEntry[overSide]);
			const underAm = decimalToAmerican(sharpEntry[underSide]);

			const overDiff = Math.abs(overAm - roundedMain.sharpOver) / Math.abs(roundedMain.sharpOver);
			const underDiff = Math.abs(underAm - roundedMain.sharpUnder) / Math.abs(roundedMain.sharpUnder);

			result.sharpChanged.over = overDiff > 0.05;
			result.sharpChanged.under = underDiff > 0.05;
		}

		// Phrase generation
		const dumbChanges = [];
		if (result.dumbChanged.over) dumbChanges.push('over');
		if (result.dumbChanged.under) dumbChanges.push('under');

		const sharpChanges = [];
		if (result.sharpChanged.over) sharpChanges.push('over');
		if (result.sharpChanged.under) sharpChanges.push('under');

		// let phraseParts = [];

		// if (dumbChanges.length) {
		// 	phraseParts.push(`price changed (${dumbChanges.join(' and ')})`);
		// }

		// if (sharpChanges.length && mainObj.sharp_filter.length === 1) {
		// 	phraseParts.push(`fair value changed (${sharpChanges.join(' and ')})`);
		// }

		// result.phrase = phraseParts.join(' and ');

		return result;
	} catch (e) {
		//
		return '';
	}
}

export const RelatedOddsDropdown = (props) => {
	const {
		tutorial,
		relatedOdds,
		isOver,
		sportsbooksToHighlight,
		outcome_id_normalized,
		sharpBook,
		sharpFilter,
		sportsbook_dumb,
		isMobile,
		selectedRow,
		selectedSport,
		overSide,
		underSide,
		isLive,
		sharpPriceOver,
		sharpPriceUnder,
		isArbitrage,
		isSpread,
		onClose,
	} = props;


	const [debouncedPricesChanged, setDebouncedPricesChanged] = useState(null);
	const debounceTimeout = useRef(null);

	useEffect(() => {
		if (debounceTimeout.current) {
			clearTimeout(debounceTimeout.current);
		}
		debounceTimeout.current = setTimeout(() => {
			setDebouncedPricesChanged(checkIfPricesChanged(selectedRow, relatedOdds, overSide, underSide));
		}, 300);

		return () => clearTimeout(debounceTimeout.current);
	}, [selectedRow, relatedOdds, overSide, underSide]);

	const accessToken = window.localStorage.getItem('access_token');

	const [additionalSportsbooksToHighlight, setAdditionalSportsbooksToHighlight] = useState([]);
	const [sportsbookSearchOpen, setSportsbookSearchOpen] = useState(false);
	const [sportsbookSearchTerm, setSportsbookSearchTerm] = useState('');
	const sportsbookDropdownRef = useRef(null);
	
	// Close dropdown when clicking outside
	useEffect(() => {
		if (!sportsbookSearchOpen) return;
		
		const handleClickOutside = (event) => {
			if (sportsbookDropdownRef.current && !sportsbookDropdownRef.current.contains(event.target)) {
				setSportsbookSearchOpen(false);
				setSportsbookSearchTerm('');
			}
		};
		
		// Use setTimeout to avoid immediate closure when opening
		const timeoutId = setTimeout(() => {
			document.addEventListener('mousedown', handleClickOutside, true);
		}, 100);
		
		return () => {
			clearTimeout(timeoutId);
			document.removeEventListener('mousedown', handleClickOutside, true);
		};
	}, [sportsbookSearchOpen]);

	const [oddsHistories, setOddsHistories] = useState();

	// For Point Spread/Asian Handicap: fetch the opponent team's related odds (other side of the bet)
	const [otherSideRelatedOdds, setOtherSideRelatedOdds] = useState([]);

	const [order, setOrder] = useState('asc');
	const [orderBy, setOrderBy] = useState('');

	const outcomesplit = outcome_id_normalized.split(':');
	// For spreads, the right column (away team) uses underSide, left column (home team) uses overSide
	const isSpreadMarket = (isSpread && (outcomesplit?.[1] === 'Point Spread' || outcomesplit?.[1] === 'Asian Handicap'));

	// Helper function to deduplicate odds by normalized sportsbook name and prices
	const deduplicateOdds = (oddsArray, overSideKey, underSideKey, isSpreadMarket) => {
		const deduplicated = [];
		const seenEntries = new Map(); // key: normalizedSportsbook:overPrice:underPrice
		
		oddsArray.forEach(odd => {
			const normalizedBook = normalizeSportsbookName(odd.sportsbook);
			const overPrice = pickPrice(odd, overSideKey, isSpreadMarket);
			const underPrice = pickPrice(odd, underSideKey, isSpreadMarket);
			
			// Create a unique key based on normalized book name and prices
			const key = `${normalizedBook}:${overPrice}:${underPrice}`;
			
			if (!seenEntries.has(key)) {
				// First time seeing this combination - add it
				seenEntries.set(key, odd);
				deduplicated.push(odd);
			} else {
				// Duplicate found - prefer FanDuel over Betway (Alaska)
				const existingOdd = seenEntries.get(key);
				
				// If existing is an alias row and current is the preferred display name, replace it
				if (shouldPreferSportsbookRow(odd.sportsbook, existingOdd.sportsbook)) {
					const index = deduplicated.indexOf(existingOdd);
					if (index !== -1) {
						deduplicated[index] = odd;
						seenEntries.set(key, odd);
					}
				}
				// Otherwise, keep the existing entry (don't add the duplicate)
			}
		});
		
		return deduplicated;
	};

	// Deduplicate relatedOdds early for use in calculations
	const relatedOddsDeduped = relatedOdds ? deduplicateOdds(relatedOdds, overSide, underSide, isSpread) : relatedOdds;

	const numberOfOvers = relatedOddsDeduped?.filter((e) => pickPrice(e, overSide, isSpread) != null).length;
	
	// Map the price keys for opponent team's data (perspective flips)
	// The opponent has the opposite sign spread:
	// - Away +X (bet_price_under_positive) → opponent is Home -X (bet_price_over_negative)
	// - Away -X (bet_price_under_negative) → opponent is Home +X (bet_price_over_positive)
	// - Home +X (bet_price_over_positive) → opponent is Away -X (bet_price_under_negative)
	// - Home -X (bet_price_over_negative) → opponent is Away +X (bet_price_under_positive)
	let rightColumnKey = underSide;
	if (isSpreadMarket) {
		if (underSide === 'bet_price_under_positive') {
			rightColumnKey = 'bet_price_over_negative';
		} else if (underSide === 'bet_price_under_negative') {
			rightColumnKey = 'bet_price_over_positive';
		} else if (overSide === 'bet_price_over_positive') {
			rightColumnKey = 'bet_price_under_negative';
		} else if (overSide === 'bet_price_over_negative') {
			rightColumnKey = 'bet_price_under_positive';
		}
	}
	
	const undersSource = isSpreadMarket ? otherSideRelatedOdds : relatedOddsDeduped;
	const numberOfUnders = undersSource?.filter((e) => pickPrice(e, rightColumnKey, isSpread) != null).length;

	// Calculate average by converting to decimal, averaging, then converting back to American
	const averageOver = numberOfOvers
		? (() => {
				const decimalOdds = relatedOddsDeduped
					.filter((e) => pickPrice(e, overSide, isSpread) != null)
					.map((e) => {
						try {
							const americanOdds = pickPrice(e, overSide, isSpread);
							if (americanOdds == null) return null;
							return parseFloat(americanToDecimal(americanOdds));
						} catch (err) {
							return null;
						}
					})
					.filter((d) => d != null);
				if (decimalOdds.length === 0) return 0;
				const avgDecimal = decimalOdds.reduce((total, next) => total + next, 0) / decimalOdds.length;
				const result = decimalToAmerican(avgDecimal);
				return result != null ? result : 0;
			})()
		: 0;
	const averageUnder = numberOfUnders
		? (() => {
				const decimalOdds = undersSource
					.filter((e) => pickPrice(e, rightColumnKey, isSpread) != null)
					.map((e) => {
						try {
							const americanOdds = pickPrice(e, rightColumnKey, isSpread);
							if (americanOdds == null) return null;
							return parseFloat(americanToDecimal(americanOdds));
						} catch (err) {
							return null;
						}
					})
					.filter((d) => d != null);
				if (decimalOdds.length === 0) return 0;
				const avgDecimal = decimalOdds.reduce((total, next) => total + next, 0) / decimalOdds.length;
				const result = decimalToAmerican(avgDecimal);
				return result != null ? result : 0;
			})()
		: 0;

	const highOver = Math.max(
		...relatedOddsDeduped
			?.filter((e) => pickPrice(e, overSide, isSpread) != null)
			?.map((o) => pickPrice(o, overSide, isSpread))
	);
	const highUnder = Math.max(
		...undersSource
			?.filter((e) => pickPrice(e, rightColumnKey, isSpread) != null)
			?.map((o) => pickPrice(o, rightColumnKey, isSpread))
	);

// moved up
	// start with sportsbookToHighlight array. Get the odds history and show the graphs for both sides of the bets (for the sportsbooks to highlight)
	const [selected, setSelected] = useState(!isLive ? 'all' : '15m');

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);
	const [selectedSide, setSelectedSide] = useState(isOver ? 'over' : 'under');

	const userdb = JSON.parse(window.localStorage.getItem('userdb'));
	const isMasterOrApprentice =
		(userdb?.stripe_plan?.nickname?.includes('Visionary') &&
			userdb?.stripe_plan.active &&
			userdb?.stripe_subscription !== null &&
			userdb?.stripe_status !== 'deleted' &&
			userdb.stripe_status !== 'past_due') ||
		(userdb?.stripe_plan?.nickname?.includes('Apprentice') &&
			userdb?.stripe_plan.active &&
			userdb?.stripe_subscription !== null &&
			userdb?.stripe_status !== 'deleted' &&
			userdb.stripe_status !== 'past_due');

	useEffect(() => {
		// Remove duplicates when splitting by comma
		let sharps = sharpBook ? [...new Set(sharpBook.split(',').map(b => b.trim()))] : [];

		if (sharpFilter?.includes('WagerWiz')) {
			sharps = ['WagerWiz'];
		}
		const split = outcome_id_normalized.split(':');
		let outcome_id_normalized_arr = [];
		const addUnique = (id) => {
			if (id && !outcome_id_normalized_arr.includes(id)) {
				outcome_id_normalized_arr.push(id);
			}
		};

		// Helper: build points-form ID for spreads (game:Point Spread:Team:±points)
				const buildPointsFormId = () => {
			try {
				const gameId = split[0];
				const marketStr = split[1];
				const team = split[2];
				// If split[3] already looks like a points number (e.g., -6.5 or +6.5), use it directly
				const maybePoints = split[3];
				if (maybePoints && /^[-+]?\d+(?:\.\d+)?$/.test(maybePoints)) {
							// Normalize: drop leading '+' for positives
							const normalized = `${maybePoints}`.replace(/^\+/, '');
							return `${gameId}:${marketStr}:${team}:${normalized}`;
				}
				// Else, derive points and sign from selectedRow
				const rawPoints = selectedRow?.points;
				if (rawPoints == null) return null;
				const homeTeam = selectedRow?.game?.home_team_display || selectedRow?.home_team;
						// Invert previous rule and emit positive without '+'
						const isPositive = team === homeTeam; // home -> positive, away -> negative
						const pointsVal = isPositive ? `${rawPoints}` : `-${rawPoints}`;
						return `${gameId}:${marketStr}:${team}:${pointsVal}`;
			} catch (e) {
				return null;
			}
		};
		
		// Check if Moneyline has ":vs:" in outcome_id_normalized_no_book
		const isMoneylineWithVs = split[1] === 'Moneyline' && 
			selectedRow?.outcome_id_normalized_no_book && 
			selectedRow.outcome_id_normalized_no_book.includes(':vs:');
		
		// Add the base outcome_id_normalized first
		if (split[1] === 'Point Spread' || split[1] === 'Asian Handicap') {
			// For spreads, do not add a lone ID; we'll add per-book points-form IDs below
		} else if (split[1] === 'Moneyline') {
			// For Moneyline with ":vs:", don't add base ID - we'll handle it per-book below
			if (!isMoneylineWithVs) {
				addUnique(outcome_id_normalized);
			}
		} else {
			// For non-spread/non-moneyline bets, add over and under versions of the base outcome ID
			const baseOver = `${split[0]}:${split[1]}:${split[2]}:${split[3]}:over:${split[4]}`;
			const baseUnder = `${split[0]}:${split[1]}:${split[2]}:${split[3]}:under:${split[4]}`;
			addUnique(baseOver);
			addUnique(baseUnder);
		}

		// For arbitrage, reset the array, but skip if it's Moneyline with :vs: (we'll handle it per-book)
		if (isArbitrage && !isMoneylineWithVs) {
			const splitId = outcome_id_normalized.split(':');

			outcome_id_normalized_arr = [
				`${splitId[0]}:${splitId[1]}:${splitId[2]}:${splitId[3]}:${splitId[4]}`,
				`${splitId[0]}:${splitId[1]}:${splitId[2]}:${splitId[3]}:${splitId[5]}`,
			];
		}

		// Include sportsbook_dumb in the books to process
		const allBooksSet = new Set([...sharps, ...additionalSportsbooksToHighlight]);
		if (sportsbook_dumb) {
			allBooksSet.add(sportsbook_dumb);
		}
		const allBooks = Array.from(allBooksSet);
		
		// Debug: log what books we're processing
		if (split[1] === 'Moneyline' && isMoneylineWithVs) {
			console.log('Moneyline with :vs: detected. allBooks:', allBooks, 'sharps:', sharps, 'additionalSportsbooksToHighlight:', additionalSportsbooksToHighlight, 'sportsbook_dumb:', sportsbook_dumb);
		}
		
		for (let i = 0; i < allBooks.length; i++) {
			const book = allBooks[i];
			if (split[1] === 'Point Spread' || split[1] === 'Asian Handicap') {
				// For spreads, send points-form per-book IDs: game:Point Spread:Team:±points:None:<book>
				const pointsFormId = buildPointsFormId();
				if (pointsFormId) {
					const pointsSplit = pointsFormId.split(':');
					const pointsVal = `${pointsSplit[3]}`;
					const unsigned = pointsVal.replace(/^[-+]/, '');
					const perBookId = `${pointsSplit[0]}:${pointsSplit[1]}:${pointsSplit[2]}:${pointsVal}:None:${book}`;
					addUnique(perBookId);
					// Add the other side (flip sign; positive side uses no plus sign)
					const flipped = pointsVal.startsWith('-') ? unsigned : `-${unsigned}`;
					const perBookIdOtherSide = `${pointsSplit[0]}:${pointsSplit[1]}:${pointsSplit[2]}:${flipped}:None:${book}`;
					addUnique(perBookIdOtherSide);

					// Also include the opponent team's spread entries (both signs)
					try {
						const homeTeam = selectedRow?.game?.home_team_display || selectedRow?.home_team;
						const awayTeam = selectedRow?.game?.away_team_display || selectedRow?.away_team;
						const currentTeam = pointsSplit[2];
						const opponentTeam = currentTeam === homeTeam ? awayTeam : homeTeam;
						if (opponentTeam) {
							const oppPerBookId = `${pointsSplit[0]}:${pointsSplit[1]}:${opponentTeam}:${pointsVal}:None:${book}`;
							addUnique(oppPerBookId);
							const oppPerBookIdOther = `${pointsSplit[0]}:${pointsSplit[1]}:${opponentTeam}:${flipped}:None:${book}`;
							addUnique(oppPerBookIdOther);
						}
					} catch (e) {}
				}
			} else if (split[1] === 'Moneyline') {
				// For Moneyline with ":vs:", create per-book IDs for both teams
				if (isMoneylineWithVs && selectedRow?.outcome_id_normalized_no_book) {
					const noBookId = selectedRow.outcome_id_normalized_no_book;
					const splitNoBook = noBookId.split(':');
					// Format: "32700-65233-2025-11-04:Moneyline:Stanford:vs:Portland State"
					if (splitNoBook.length >= 5 && splitNoBook[3] === 'vs') {
						const gameId = splitNoBook[0];
						const marketStr = splitNoBook[1];
						const team1 = splitNoBook[2];
						const team2 = splitNoBook[4];
						
						// Add team1 per-book ID: "32700-65233-2025-11-04:Moneyline:Stanford::None:Sportzino"
						const team1PerBookId = `${gameId}:${marketStr}:${team1}::None:${book}`;
						addUnique(team1PerBookId);
						
						// Add team2 per-book ID: "32700-65233-2025-11-04:Moneyline:Portland State::None:Sportzino"
						const team2PerBookId = `${gameId}:${marketStr}:${team2}::None:${book}`;
						addUnique(team2PerBookId);
						
						// Debug: log what we're adding
						if (split[1] === 'Moneyline' && isMoneylineWithVs) {
							console.log(`Added IDs for book ${book}:`, team1PerBookId, team2PerBookId);
						}
					}
				} else {
					// For regular Moneyline (without ":vs:"), use the original format
					const outcomeid = `${split[0]}:${split[1]}:${book}`;
					addUnique(outcomeid);
				}
			} else {
				// Add over and under sides for each sportsbook
				const outcomeidOver = `${split[0]}:${split[1]}:${split[2]}:${split[3]}:over:${book}`;
				const outcomeidUnder = `${split[0]}:${split[1]}:${split[2]}:${split[3]}:under:${book}`;
				addUnique(outcomeidOver);
				addUnique(outcomeidUnder);
			}
		}

		// Filter out any Moneyline IDs with ":vs:" (they should be split into per-book IDs)
		const filteredArr = outcome_id_normalized_arr.filter(id => {
			if (split[1] === 'Moneyline' && id && id.includes(':vs:')) {
				return false;
			}
			return true;
		});

		// Debug: log final array
		// if (split[1] === 'Moneyline' && isMoneylineWithVs) {
		// 	console.log('Final outcome_id_normalized_arr:', outcome_id_normalized_arr);
		// 	console.log('Filtered array:', filteredArr);
		// }
		// console.log('Filtered array:', filteredArr);
		
		axios
			.get(`${process.env.REACT_APP_BACKEND_URL}/outcomes_history?outcome_id_normalized=${filteredArr.join(',')}&sport=${selectedRow?.sport || selectedSport}`, {
				headers: {
					Authorization: `Bearer ${accessToken}`,
				},
			})
			.then((r) => {
				// Process Moneyline with :vs: data - reorganize team2 prices to bet_price_under_history
				let processedData = r.data;
				if (isMoneylineWithVs && selectedRow?.outcome_id_normalized_no_book && Array.isArray(r.data)) {
					const noBookId = selectedRow.outcome_id_normalized_no_book;
					const splitNoBook = noBookId.split(':');
					if (splitNoBook.length >= 5 && splitNoBook[3] === 'vs') {
						const team1 = splitNoBook[2];
						const team2 = splitNoBook[4];
						
						// Determine which team is home and which is away
						const homeTeam = selectedRow?.game?.home_team_display || selectedRow?.home_team;
						const awayTeam = selectedRow?.game?.away_team_display || selectedRow?.away_team;
						
						// Identify home and away team entries
						// team1 and team2 come from the outcome_id_normalized_no_book format
						// We need to match them to home/away teams
						let homeTeamName = null;
						let awayTeamName = null;
						
						if (team1 === homeTeam) {
							homeTeamName = team1;
							awayTeamName = team2;
						} else if (team2 === homeTeam) {
							homeTeamName = team2;
							awayTeamName = team1;
						} else if (team1 === awayTeam) {
							homeTeamName = team2;
							awayTeamName = team1;
						} else if (team2 === awayTeam) {
							homeTeamName = team1;
							awayTeamName = team2;
						} else {
							// Fallback: assume team1 is home, team2 is away
							homeTeamName = team1;
							awayTeamName = team2;
						}
						
						// Group entries by sportsbook
						const bySportsbook = new Map();
						r.data.forEach(entry => {
							if (!bySportsbook.has(entry.sportsbook)) {
								bySportsbook.set(entry.sportsbook, []);
							}
							bySportsbook.get(entry.sportsbook).push(entry);
						});
						
						// Process each sportsbook's entries
						processedData = [];
						bySportsbook.forEach((entries, sportsbook) => {
							// Find home and away team entries by matching the team name in outcome_id_normalized
							// Format: "32700-65233-2025-11-04:Moneyline:Stanford::None:BookMaker"
							const homeEntry = entries.find(e => {
								if (!e.outcome_id_normalized) return false;
								const entrySplit = e.outcome_id_normalized.split(':');
								// Check if entrySplit[2] matches home team
								return entrySplit.length >= 3 && entrySplit[2] === homeTeamName;
							});
							const awayEntry = entries.find(e => {
								if (!e.outcome_id_normalized) return false;
								const entrySplit = e.outcome_id_normalized.split(':');
								// Check if entrySplit[2] matches away team
								return entrySplit.length >= 3 && entrySplit[2] === awayTeamName;
							});
							
							if (homeEntry && awayEntry) {
								// Create merged entry with home team prices in over and away team prices in under
								const mergedEntry = {
									...homeEntry,
									sportsbook: sportsbook,
									bet_price_over_history: homeEntry.bet_price_over_history, // Home team -> over
									bet_price_under_history: awayEntry.bet_price_over_history, // Away team's over history -> under
								};
								processedData.push(mergedEntry);
							} else if (homeEntry || awayEntry) {
								// If we only have one team, add it as-is
								processedData.push(...entries);
							} else {
								// If we can't find either, just add the entries as-is
								processedData.push(...entries);
							}
						});
					}
				}
				setOddsHistories(processedData);
			})
			.catch((e) => {});

		// Additionally, for spreads, fetch the opponent team's related odds (no book)
		try {
			if ((split[1] === 'Point Spread' || split[1] === 'Asian Handicap') && (selectedRow?.game || selectedRow)) {
				const gameId = split[0];
				const marketStr = split[1];
				const team = split[2];
				const homeTeam = selectedRow?.game?.home_team_display || selectedRow?.home_team;
				const awayTeam = selectedRow?.game?.away_team_display || selectedRow?.away_team;
				const opponentTeam = team === homeTeam ? awayTeam : homeTeam;
				
				// Determine points value based on which side we're looking at (overSide/underSide)
				// The opponent always has the opposite sign spread:
				// - Away +X (bet_price_under_positive) → opponent is Home -X
				// - Away -X (bet_price_under_negative) → opponent is Home +X
				// - Home +X (bet_price_over_positive) → opponent is Away -X
				// - Home -X (bet_price_over_negative) → opponent is Away +X
				let opponentPoints = null;
				const rawPoints = selectedRow?.points;
				if (rawPoints != null) {
					// Determine which team the opponent is
					const opponentIsAway = opponentTeam === awayTeam;
					const opponentIsHome = opponentTeam === homeTeam;
					
					// When underSide is bet_price_under_positive (away +X), opponent (home) has -X
					if (underSide === 'bet_price_under_positive' && opponentIsHome) {
						opponentPoints = `-${rawPoints}`;
					}
					// When underSide is bet_price_under_negative (away -X), opponent (home) has +X
					else if (underSide === 'bet_price_under_negative' && opponentIsHome) {
						opponentPoints = `${rawPoints}`;
					}
					// When overSide is bet_price_over_positive (home +X), opponent (away) has -X
					else if (overSide === 'bet_price_over_positive' && opponentIsAway) {
						opponentPoints = `-${rawPoints}`;
					}
					// When overSide is bet_price_over_negative (home -X), opponent (away) has +X
					else if (overSide === 'bet_price_over_negative' && opponentIsAway) {
						opponentPoints = `${rawPoints}`;
					}
					// Default: use absolute value (positive without '+')
					else {
						opponentPoints = `${rawPoints}`;
					}
				}

				if (opponentTeam && opponentPoints) {
					const noBookId = `${gameId}:${marketStr}:${opponentTeam}:${opponentPoints}`;
					axios
						.get(`${process.env.REACT_APP_BACKEND_URL}/related_outcomes?outcome_id_normalized_no_book=${encodeURIComponent(noBookId)}&sport=${selectedRow?.sport || selectedSport}`,
							{
								headers: { Authorization: `Bearer ${accessToken}` },
							}
						)
						.then((resp) => {
							setOtherSideRelatedOdds(Array.isArray(resp?.data) ? resp.data : (resp?.data?.related_odds || []));
						})
						.catch(() => setOtherSideRelatedOdds([]));
				} else {
					setOtherSideRelatedOdds([]);
				}
			} else {
				setOtherSideRelatedOdds([]);
			}
		} catch (e) {
			setOtherSideRelatedOdds([]);
		}
	}, [outcome_id_normalized, sharpBook, additionalSportsbooksToHighlight, accessToken, isArbitrage, selectedRow?.sport, selectedSport, sharpFilter, selectedRow?.points, selectedRow, overSide, underSide]);

	const relatedOddsAndCustom = [...relatedOddsDeduped];
	if (sharpFilter?.includes('WagerWiz Props') || sharpFilter?.includes('WagerWiz Mains') || sharpFilter?.includes('WagerWiz')) {
		// Use fair values (devigged odds) instead of odds with vig for all market types
		let wagerWizOver = sharpPriceOver;
		let wagerWizUnder = sharpPriceUnder;
		
		if (sharpPriceOver && sharpPriceUnder) {
			// Parse the formatted prices back to numbers
			// formatPrice returns strings like "+150" or "-110"
			const parsePrice = (priceStr) => {
				if (!priceStr) return null;
				// Remove + sign if present, then parse as integer
				const cleaned = priceStr.toString().replace(/^\+/, '').trim();
				const num = parseInt(cleaned, 10);
				return isNaN(num) ? null : num;
			};
			
			const overOddsNum = parsePrice(sharpPriceOver);
			const underOddsNum = parsePrice(sharpPriceUnder);
			
			if (overOddsNum != null && underOddsNum != null) {
				// Calculate fair values by removing vig
				const devigged = devigOddsProbit(overOddsNum, underOddsNum);
				wagerWizOver = formatPrice(devigged.overOdds);
				wagerWizUnder = formatPrice(devigged.underOdds);
			}
		}
		
		relatedOddsAndCustom.unshift({
			sportsbook: 'WagerWiz',
			bet_price_over: wagerWizOver,
			bet_price_under: wagerWizUnder,
			bet_price_over_positive: wagerWizOver,
			bet_price_under_positive: wagerWizUnder,
			bet_price_over_negative: wagerWizOver,
			bet_price_under_negative: wagerWizUnder,
		});
		relatedOddsAndCustom.sort((a, b) => {
			if (a.sportsbook === 'WagerWiz') return -1;
			if (b.sportsbook === 'WagerWiz') return 1;
			return 0;
		});
	}

	// Final deduplication after WagerWiz is added (in case WagerWiz handling introduced any duplicates)
	const relatedOddsAndCustomDeduped = deduplicateOdds(relatedOddsAndCustom, overSide, rightColumnKey, isSpread);

	let spreadPhrase = '';
	let spreadPhraseUnder = '';
	let moneylineTeamOver = '';
	let moneylineTeamUnder = '';

	if (outcomesplit[1] === 'Point Spread' || outcomesplit[1] === 'Asian Handicap') {
		// Points are expected at index 3 for normalized spread IDs: game:Point Spread:Team:±points:...
		// Fallback to selectedRow.points if outcomesplit[3] is not available or invalid
		let pointsStr = outcomesplit[3];
		if (!pointsStr || pointsStr === 'vs' || pointsStr === '' || isNaN(parseFloat(pointsStr?.replace(/^[+-]/, '')))) {
			pointsStr = selectedRow?.points != null ? `${selectedRow.points}` : '';
		}
		
		// Get absolute value for cleanPoints (remove sign)
		const cleanPoints = pointsStr ? `${pointsStr}`.replace(/^[+-]/, '') : (selectedRow?.points != null ? `${Math.abs(selectedRow.points)}` : '');
		const homeTeam = selectedRow?.game?.home_team_display || selectedRow?.home_team || '';
		const awayTeam = selectedRow?.game?.away_team_display || selectedRow?.away_team || '';
		
		if (selectedRow.ev_spread === selectedRow.ev_over_positive) {
			spreadPhrase = `${homeTeam} +${cleanPoints}`;
			spreadPhraseUnder = `${awayTeam} -${cleanPoints}`;
		} else if (selectedRow.ev_spread === selectedRow.ev_under_positive) {
			spreadPhraseUnder = `${awayTeam} +${cleanPoints}`;
			spreadPhrase = `${homeTeam} -${cleanPoints}`;
		} else if (selectedRow.ev_spread === selectedRow.ev_over_negative) {
			spreadPhraseUnder = `${awayTeam} -${cleanPoints}`;
			spreadPhrase = `${homeTeam} +${cleanPoints}`;
		} else if (selectedRow.ev_spread === selectedRow.ev_under_negative) {
			spreadPhrase = `${homeTeam} -${cleanPoints}`;
			spreadPhraseUnder = `${awayTeam} +${cleanPoints}`;
		} else {
			// Fallback: determine based on the team in outcomesplit[2] and points sign
			const currentTeam = outcomesplit[2] || '';
			const isCurrentTeamHome = currentTeam === homeTeam;
			const rawPoints = selectedRow?.points != null ? selectedRow.points : (pointsStr ? parseFloat(pointsStr) : null);
			
			if (rawPoints != null && cleanPoints) {
				const isNegative = rawPoints < 0;
				const absPoints = Math.abs(rawPoints);
				
				if (isCurrentTeamHome) {
					if (isNegative) {
						spreadPhrase = `${homeTeam} -${absPoints}`;
						spreadPhraseUnder = `${awayTeam} +${absPoints}`;
					} else {
						spreadPhrase = `${homeTeam} +${absPoints}`;
						spreadPhraseUnder = `${awayTeam} -${absPoints}`;
					}
				} else {
					if (isNegative) {
						spreadPhrase = `${awayTeam} -${absPoints}`;
						spreadPhraseUnder = `${homeTeam} +${absPoints}`;
					} else {
						spreadPhrase = `${awayTeam} +${absPoints}`;
						spreadPhraseUnder = `${homeTeam} -${absPoints}`;
					}
				}
			} else if (homeTeam && awayTeam) {
				// Last resort: just show team names without points
				spreadPhrase = homeTeam;
				spreadPhraseUnder = awayTeam;
			}
		}
	} else if (outcomesplit[1] === 'Moneyline') {
		// For moneylines, the "over" column shows the current team (outcomesplit[2])
		// and the "under" column shows the opponent team
		const currentTeam = outcomesplit[2];
		const homeTeam = selectedRow?.game?.home_team_display || selectedRow?.home_team;
		const awayTeam = selectedRow?.game?.away_team_display || selectedRow?.away_team;
		
		// The current team is always in the "over" position
		moneylineTeamOver = currentTeam;
		
		// Determine the opponent team
		if (currentTeam === homeTeam) {
			moneylineTeamUnder = awayTeam || '';
		} else if (currentTeam === awayTeam) {
			moneylineTeamUnder = homeTeam || '';
		} else {
			// Fallback: if we can't match, try the other team
			moneylineTeamUnder = (homeTeam && homeTeam !== currentTeam) ? homeTeam : (awayTeam && awayTeam !== currentTeam ? awayTeam : '');
		}
	}

	

	if (!isMobile) {
		return (
			<div className="flex flex-row" style={{ backgroundColor: '#17191d', minHeight: '600px' }}>
				<div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
					<div className="flex flex-row items-center justify-between" style={{ backgroundColor: '#363844', height: '40px', alignContent: 'center', color: '#eff1f5', paddingLeft: '12px', paddingRight: '12px', flexShrink: 0 }}>
						<div>
							{(outcomesplit[1] === 'Point Spread' || outcomesplit[1] === 'Asian Handicap') && (
								<>
									{selectedSide === 'over' ? spreadPhrase : spreadPhraseUnder}
								</>
							)}
							{outcomesplit[1] === 'Moneyline' && (
								<>
									{outcomesplit[2]}
								</>
							)}
							{(outcomesplit[1] !== 'Point Spread' && outcomesplit[1] !== 'Asian Handicap' && outcomesplit[1] !== 'Moneyline') && (
								<>
									{outcomesplit[2]} {selectedSide} {outcomesplit[3]}
								</>
							)}
						</div>
					</div>
					<div className="pt-2 pl-6 flex flex-row items-center" style={{ flexShrink: 0 }}>
						{/* Sportsbooks Dropdown Button */}
						<div style={{ position: 'relative' }} ref={sportsbookDropdownRef}>
						{(() => {
							// Get all unique sportsbooks from relatedOdds
							const allSportsbooks = new Set();
							(relatedOdds || []).forEach(odd => {
								if (odd?.sportsbook) {
									allSportsbooks.add(odd.sportsbook);
								}
							});
							
							// Add WagerWiz if in sharp filter
							if (sharpFilter?.includes('WagerWiz Props') || sharpFilter?.includes('WagerWiz Mains') || sharpFilter?.includes('WagerWiz')) {
								allSportsbooks.add('WagerWiz');
							}
							
							// Normalize and dedupe
							const normalizeBook = (book) => {
								let normalized = getSportsbookDisplayName(book);
								if ((sharpFilter?.includes('WagerWiz Props') || sharpFilter?.includes('WagerWiz Mains') || sharpFilter?.includes('WagerWiz')) && book !== sportsbook_dumb) {
									normalized = 'WagerWiz';
								}
								return normalized;
							};
							
							const seen = new Set();
							const allBooksList = Array.from(allSportsbooks).map(book => {
								const normalized = normalizeBook(book);
								if (seen.has(normalized)) return null;
								seen.add(normalized);
								return { original: book, display: normalized };
							}).filter(Boolean);
							
							// Filter by search term
							const filteredBooks = allBooksList.filter(book => 
								book.display.toLowerCase().includes(sportsbookSearchTerm.toLowerCase())
							);
							
							// Get currently selected books (normalized display names)
							const selectedBooksNormalized = new Set([
								...(sportsbooksToHighlight || []).map(b => normalizeBook(b)),
								...(additionalSportsbooksToHighlight || []).map(b => normalizeBook(b))
							]);
							
							const totalSelected = selectedBooksNormalized.size;
							
							return (
								<>
									<button
										onClick={(e) => {
											e.stopPropagation();
											setSportsbookSearchOpen(!sportsbookSearchOpen);
										}}
										style={{
											display: 'flex',
											alignItems: 'center',
											gap: '8px',
											padding: '8px 12px',
											backgroundColor: '#1a1d24',
											border: '1px solid #363844',
											borderRadius: '8px',
											color: '#eff1f5',
											cursor: 'pointer',
											fontSize: '14px',
											fontWeight: '500',
											minWidth: '180px',
											justifyContent: 'space-between',
										}}
										onMouseEnter={(e) => {
											e.target.style.borderColor = '#4a4d54';
										}}
										onMouseLeave={(e) => {
											e.target.style.borderColor = '#363844';
										}}
									>
										<span>Sportsbooks</span>
										<span style={{ 
											color: 'white', 
											backgroundColor: '#0c62f6', 
											borderRadius: '12px', 
											paddingLeft: '8px', 
											paddingRight: '8px', 
											paddingTop: '2px', 
											paddingBottom: '2px',
											fontSize: '12px',
											fontWeight: '600'
										}}>
											{totalSelected}
										</span>
									</button>
									
									{sportsbookSearchOpen && (
										<div
											style={{
												position: 'absolute',
												top: '100%',
												left: 0,
												marginTop: '4px',
												backgroundColor: '#1a1d24',
												border: '1px solid #363844',
												borderRadius: '8px',
												boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
												zIndex: 10000,
												minWidth: '250px',
												maxWidth: '350px',
												maxHeight: '400px',
												display: 'flex',
												flexDirection: 'column',
											}}
											onClick={(e) => e.stopPropagation()}
											onMouseDown={(e) => e.stopPropagation()}
										>
											{/* Search Bar */}
											<div style={{
												display: 'flex',
												flexDirection: 'row',
												alignItems: 'center',
												gap: '8px',
												border: '1px solid #363844',
												borderRadius: '6px',
												padding: '8px 12px',
												margin: '8px',
												backgroundColor: '#17191d',
											}}>
												<img src={magnifying_glass} alt="search" style={{ width: '16px', height: '16px', opacity: 0.7 }} />
												<input
													type="text"
													value={sportsbookSearchTerm}
													onChange={(e) => setSportsbookSearchTerm(e.target.value)}
													placeholder="Search sportsbooks..."
													style={{
														flex: 1,
														backgroundColor: 'transparent',
														border: 'none',
														outline: 'none',
														color: '#eff1f5',
														fontSize: '14px',
													}}
													onClick={(e) => e.stopPropagation()}
												/>
											</div>
											
											{/* Options List */}
											<div style={{
												maxHeight: '300px',
												overflowY: 'auto',
												padding: '4px',
											}}>
												{filteredBooks.map((book) => {
													const isInMainHighlight = (sportsbooksToHighlight || []).some(b => normalizeBook(b) === book.display);
													const isSelected = selectedBooksNormalized.has(book.display);
													
													return (
														<div
															key={book.display}
															onClick={(e) => {
																e.stopPropagation();
																if (isInMainHighlight) return;
																
																if (isSelected) {
																	// Remove from additional
																	const originalName = additionalSportsbooksToHighlight?.find(b => normalizeBook(b) === book.display);
																	setAdditionalSportsbooksToHighlight(additionalSportsbooksToHighlight.filter(b => b !== originalName));
																} else {
																	// Add to additional
																	setAdditionalSportsbooksToHighlight([...new Set([...(additionalSportsbooksToHighlight || []), book.original])]);
																}
															}}
															style={{
																display: 'flex',
																alignItems: 'center',
																gap: '10px',
																padding: '10px 12px',
																borderRadius: '6px',
																margin: '2px 0',
																backgroundColor: isSelected ? 'rgba(12, 98, 246, 0.15)' : 'transparent',
																color: isInMainHighlight ? '#8a8f9a' : '#eff1f5',
																opacity: isInMainHighlight ? 0.7 : 1,
																cursor: isInMainHighlight ? 'default' : 'pointer',
															}}
															onMouseEnter={(e) => {
																if (!isInMainHighlight) {
																	e.currentTarget.style.backgroundColor = isSelected ? 'rgba(12, 98, 246, 0.25)' : 'rgba(255, 255, 255, 0.08)';
																}
															}}
															onMouseLeave={(e) => {
																e.currentTarget.style.backgroundColor = isSelected ? 'rgba(12, 98, 246, 0.15)' : 'transparent';
															}}
														>
															<div style={{ 
																width: '32px', 
																height: '32px', 
																display: 'flex', 
																alignItems: 'center', 
																justifyContent: 'center',
																flexShrink: 0,
																alignSelf: 'center'
															}}>
																<div style={{
																	display: 'flex',
																	alignItems: 'center',
																	justifyContent: 'center',
																	width: '100%',
																	height: '100%'
																}}>
																	<LogoGenerator sportsbook={book.display} smallLogos={true} />
																</div>
															</div>
															<span style={{ 
																fontSize: '14px',
																fontWeight: isSelected ? '600' : '400',
																flex: 1,
																display: 'flex',
																alignItems: 'center',
																lineHeight: '1'
															}}>
																{book.display}
															</span>
															{isSelected && (
																<span style={{ 
																	color: '#0c62f6',
																	fontSize: '16px',
																	display: 'flex',
																	alignItems: 'center',
																	lineHeight: '1'
																}}>
																	✓
																</span>
															)}
														</div>
													);
												})}
											</div>
										</div>
									)}
								</>
							);
						})()}
						</div>
						<div style={{ marginLeft: 'auto', marginRight: 50, display: 'flex', alignItems: 'center', gap: '12px' }}>
							<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
								<span style={{ color: '#eff1f5', fontSize: '12px' }}>View:</span>
								<div style={{ display: 'flex', backgroundColor: '#363844', borderRadius: '6px', padding: '2px' }}>
									<button
										onClick={() => setSelectedSide('over')}
										style={{
											backgroundColor: selectedSide === 'over' ? '#1e6ffc' : 'transparent',
											color: selectedSide === 'over' ? '#ffffff' : '#b1b6c1',
											border: 'none',
											padding: '4px 8px',
											borderRadius: '3px',
											cursor: 'pointer',
											fontSize: '10px',
											fontWeight: '500',
											transition: 'all 0.2s ease'
										}}
									>
										{(outcomesplit[1] === 'Point Spread' || outcomesplit[1] === 'Asian Handicap') ? spreadPhrase : (outcomesplit[1] === 'Moneyline' ? moneylineTeamOver : 'OVER')}
									</button>
									<button
										onClick={() => setSelectedSide('under')}
										style={{
											backgroundColor: selectedSide === 'under' ? '#1e6ffc' : 'transparent',
											color: selectedSide === 'under' ? '#ffffff' : '#b1b6c1',
											border: 'none',
											padding: '4px 8px',
											borderRadius: '3px',
											cursor: 'pointer',
											fontSize: '10px',
											fontWeight: '500',
											transition: 'all 0.2s ease'
										}}
									>
										{(outcomesplit[1] === 'Point Spread' || outcomesplit[1] === 'Asian Handicap') ? spreadPhraseUnder : (outcomesplit[1] === 'Moneyline' ? moneylineTeamUnder : 'UNDER')}
									</button>
								</div>
							</div>
							<TimeRangeSelector selected={selected} setSelected={setSelected} />
						</div>
					</div>
					<UpgradeModal isOpen={isUpgradeModalOpen} setIsOpen={setIsUpgradeModalOpen} />
					<div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 0, padding: '16px' }}>
						{isMasterOrApprentice && (
							<div
								onClick={() => {
									setIsUpgradeModalOpen(true);
								}}
								style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
								<div style={{ filter: 'blur(10px)', pointerEvents: 'none', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
									<OddsHistoryGraph
										oddsHistories={oddsHistories}
										split={outcomesplit}
										additionalSportsbooksToHighlight={additionalSportsbooksToHighlight}
										setAdditionalSportsbooksToHighlight={setAdditionalSportsbooksToHighlight}
										showLogo={false}
										sharpFilter={sharpFilter}
										sharpBook={sharpBook}
										timeRange={selected}
										overSide={overSide}
										underSide={underSide}
										tutorial={tutorial}
										spreadPhrase={spreadPhraseUnder}
										selectedSide={selectedSide}
										points={selectedRow?.points}
										height={450}
									/>
								</div>
								<div
									style={{
										position: 'absolute',
										top: 0,
										left: 0,
										right: 0,
										bottom: 0,
										border: '2px solid rgba(255,255,255,0.4)',
										borderRadius: '8px',
										pointerEvents: 'none',
									}}
								/>
							</div>
						)}
						{!isMasterOrApprentice && (
							<div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
								<OddsHistoryGraph
									oddsHistories={oddsHistories}
									split={outcomesplit}
									additionalSportsbooksToHighlight={additionalSportsbooksToHighlight}
									setAdditionalSportsbooksToHighlight={setAdditionalSportsbooksToHighlight}
									showLogo={false}
									sharpFilter={sharpFilter}
									sharpBook={sharpBook}
									timeRange={selected}
									overSide={overSide}
									underSide={underSide}
									tutorial={tutorial}
									spreadPhrase={spreadPhraseUnder}
									selectedSide={selectedSide}
									height={450}
								/>
							</div>
						)}
					</div>
				</div>
				<div style={{ marginLeft: 'auto', width: '-webkit-fill-available' }}>
					<div
						className="flex flex-row fair-value"
						style={{ alignItems: 'center', backgroundColor: '#363844', height: '40px', alignContent: 'center', paddingLeft: '12px', color: '#eff1f5' }}>
						{/* {fairValue && (
							<div className="fair-value">
								Fair value: {plusOrMinusFairValue}
								{convertImpliedToAmericanOddsAbsoluteValue(fairValue)}
							</div>
						)} */}

						{debouncedPricesChanged && <div className="fair-value changed-prices">{debouncedPricesChanged.phrase}</div>}
					</div>
					<div style={{ maxHeight: 600, overflowY: 'auto' }}>
						<Table>
							<TableHead>
								<TableRow>
									<TableCell></TableCell>
									<TableCell
										onClick={() => {
											setOrderBy('bet_price_over');
											if (order === 'asc') {
												setOrder('desc');
											} else {
												setOrder('asc');
											}
										}}
										className="over-button header-with-underline"
										style={{ color: '#abb0be', cursor: 'pointer', textAlign: 'center' }}>
										{isSpread && selectedRow?.game?.home_team_display}
										{!isSpread && outcomesplit[1] === 'Moneyline' && moneylineTeamOver}
										{!isSpread && outcomesplit[1] !== 'Moneyline' && 'OVER'}
										{/* {<span>{order === 'asc' ? '↑' : '↓'}</span>} */}
									</TableCell>
									<TableCell
										onClick={() => {
											setOrderBy('bet_price_under');
											if (order === 'asc') {
												setOrder('desc');
											} else {
												setOrder('asc');
											}
										}}
										className="header-with-underline"
										style={{ color: '#abb0be', cursor: 'pointer', textAlign: 'center' }}>
									{isSpread && selectedRow?.game?.away_team_display}
									{!isSpread && outcomesplit[1] === 'Moneyline' && moneylineTeamUnder}
									{!isSpread && outcomesplit[1] !== 'Moneyline' && 'UNDER'}
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								<TableRow>
									<TableCell>
										<div style={{ backgroundColor: '#363844', padding: '6px', borderRadius: '4px', width: '48px', color: '#eff1f5', textAlign: 'center', fontSize: '12px' }}>AVG</div>
									</TableCell>
									<TableCell>
										<BetPriceDropdown price={formatPrice((averageOver))} />
									</TableCell>
									<TableCell>
										<BetPriceDropdown price={formatPrice((averageUnder))} />
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>
										<div style={{ backgroundColor: '#363844', padding: '6px', borderRadius: '4px', width: '48px', color: '#eff1f5', textAlign: 'center', fontSize: '12px' }}>HIGH</div>
									</TableCell>
									<TableCell>
										<BetPriceDropdown price={formatPrice((highOver))} />
									</TableCell>
									<TableCell>
										<BetPriceDropdown price={formatPrice((highUnder))} />
									</TableCell>
								</TableRow>
								{sortByPropertyMatch(
									sortByNumberMatch(relatedOddsAndCustomDeduped, isOver ? overSide : underSide, isOver ? highOver : highUnder),
									'sportsbook',
									sportsbooksToHighlight[sportsbooksToHighlight.length - 1]
								)
									.sort((a, b) => {
										// Priority 1: "WagerWiz" goes to the top
										if (a.sportsbook === 'WagerWiz') return -1;
										if (b.sportsbook === 'WagerWiz') return 1;

										// Priority 2: Highlighted sportsbook goes next
										const highlighted = sportsbooksToHighlight[sportsbooksToHighlight.length - 1];

										if (isArbitrage) {
											const highlighted2 = sportsbooksToHighlight[0];
											if (a.sportsbook === highlighted || a.sportsbook === highlighted2) return -1;
											if (b.sportsbook === highlighted || b.sportsbook === highlighted2) return 1;

											// Priority 3: Alphabetical order
											return a.sportsbook.localeCompare(b.sportsbook);
										} else {
											if (a.sportsbook === highlighted) return -1;
											if (b.sportsbook === highlighted) return 1;

											// Priority 3: Alphabetical order
											return a.sportsbook.localeCompare(b.sportsbook);
										}
									})
									.map((relatedRow, index) => {
										let style = {
											borderRadius: 8,
										};
										let sportsbook_name = relatedRow.sportsbook;

										if (sportsbook_dumb === relatedRow.sportsbook) {
											style.border = '2px solid #1e6ffc';
											style.backgroundColor = '#22262e';
										} else if (relatedRow.sportsbook === 'WagerWiz') {
											style.border = '2px solid #1e6ffc';
											style.backgroundColor = '#22262e';
										} else if (sharpBook === relatedRow.sportsbook) {
											// style.border = '2px solid #1e6ffc';
											// style.backgroundColor = '#22262e';
										}
										if (isArbitrage && sharpBook.includes(relatedRow.sportsbook)) {
											style.border = '2px solid #1e6ffc';
											style.backgroundColor = '#22262e';
										}

										if (additionalSportsbooksToHighlight.includes(relatedRow.sportsbook)) {
											style.border = '2px solid #1e6ffc';
											style.backgroundColor = '#22262e';
										}

										return (
											<TableRow
												style={style}
												className="cursor-pointer"
												onClick={() => {
													if (additionalSportsbooksToHighlight.includes(relatedRow.sportsbook)) {
														setAdditionalSportsbooksToHighlight(additionalSportsbooksToHighlight.filter((e) => e !== relatedRow.sportsbook));
													} else {
														setAdditionalSportsbooksToHighlight([...new Set([...additionalSportsbooksToHighlight, relatedRow.sportsbook])]);
													}
												}}>
												<TableCell>
													<LogoGenerator sportsbook={sportsbook_name} />
												</TableCell>
												<TableCell>
													<BetPriceDropdown
										price={index === 0 && relatedRow.sportsbook === 'WagerWiz' ? pickPrice(relatedRow, overSide, isSpread) : formatPrice(pickPrice(relatedRow, overSide, isSpread))}
													/>
												</TableCell>
												<TableCell>
												<BetPriceDropdown
													price={(function(){
														// For spreads, first try to get the price from relatedOdds using underSide
														// Fall back to otherSideRelatedOdds if not found
													if (isSpreadMarket) {
															// First try relatedOdds with underSide key (the other team's price may already be in the same row)
															const directVal = pickPrice(relatedRow, underSide, true);
															if (directVal != null) {
																return index === 0 && relatedRow.sportsbook === 'WagerWiz' ? directVal : formatPrice(directVal);
															}
															// Fall back to otherSideRelatedOdds
															const leftBook = normalizeSportsbookName(relatedRow?.sportsbook);
															const match = otherSideRelatedOdds?.find((r) => normalizeSportsbookName(r?.sportsbook) === leftBook);
															if (match) {
																const val = pickPrice(match, rightColumnKey, true);
																if (val != null) {
																	return index === 0 && relatedRow.sportsbook === 'WagerWiz' ? val : formatPrice(val);
																}
															}
															return null;
														}
														// Non-spread: keep existing behavior
														return index === 0 && relatedRow.sportsbook === 'WagerWiz' ? pickPrice(relatedRow, rightColumnKey, false) : formatPrice(pickPrice(relatedRow, rightColumnKey, false));
													})()}
												/>
												</TableCell>
											</TableRow>
										);
									})}
							</TableBody>
						</Table>
					</div>
				</div>
			</div>
		);
	} else {
		return (
			<div className="flex flex-row" style={{ backgroundColor: '#17191d' }}>
				<div style={{ marginLeft: 'auto', width: '-webkit-fill-available' }}>
					<div className="flex flex-row justify-between items-center" style={{ backgroundColor: '#363844', paddingRight: '12px' }}>
						<div style={{ height: '40px', alignContent: 'center', paddingLeft: '12px', color: '#eff1f5', display: 'flex', alignItems: 'center', gap: '8px' }}>
							<span
								onClick={() => {
									setIsModalOpen(!isModalOpen);
								}}
								style={{ border: '1px solid white', padding: 4, borderRadius: 6, fontSize: '10px', whiteSpace: 'nowrap' }}>
								Price History
							</span>
						</div>
						{debouncedPricesChanged && (
							<div style={{ marginTop: 'auto', marginBottom: 'auto', marginLeft: 'auto', marginRight: 14, color: '#dcdce5' }} className="fair-value changed-prices">
								{debouncedPricesChanged.phrase}
							</div>
						)}
						{/* Show sharp price instead of fair value */}
						<div style={{ marginTop: 'auto', marginBottom: 'auto', marginLeft: 'auto', marginRight: 0, color: '#dcdce5', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: '8px' }}>
							<span>
								{props.sharpPrice}
							</span>
						</div>
					</div>

					<div style={{ maxHeight: 600, overflowY: 'auto' }}>
						<Table>
							<TableHead>
								<TableRow>
									<TableCell></TableCell>
									<TableCell
										onClick={() => {
											setOrderBy('bet_price_over');
											if (order === 'asc') {
												setOrder('desc');
											} else {
												setOrder('asc');
											}
										}}
										className="over-button header-with-underline"
										style={{ color: '#abb0be', cursor: 'pointer', textAlign: 'center' }}>
										{isSpread && 'Home Team'}
										{!isSpread && outcomesplit[1] === 'Moneyline' && moneylineTeamOver}
										{!isSpread && outcomesplit[1] !== 'Moneyline' && 'OVER'}
										{/* {<span>{order === 'asc' ? '↑' : '↓'}</span>} */}
									</TableCell>
									<TableCell
										onClick={() => {
											setOrderBy('bet_price_under');
											if (order === 'asc') {
												setOrder('desc');
											} else {
												setOrder('asc');
											}
										}}
										className="header-with-underline"
										style={{ color: '#abb0be', cursor: 'pointer', textAlign: 'center' }}>
										{isSpread && selectedRow?.game?.away_team_display}
										{!isSpread && outcomesplit[1] === 'Moneyline' && moneylineTeamUnder}
										{!isSpread && outcomesplit[1] !== 'Moneyline' && 'UNDER'}
										{/* {isSpread && 'Away Team'} <span>{order === 'asc' ? '↑' : '↓'}</span>{' '} */}
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								<TableRow>
									<TableCell>
										<div style={{ backgroundColor: '#363844', padding: '6px', borderRadius: '4px', width: '48px', color: '#eff1f5', textAlign: 'center', fontSize: '12px' }}>AVG</div>
									</TableCell>
									<TableCell>
										<BetPriceDropdown price={formatPrice((averageOver))} />
									</TableCell>
									<TableCell>
										<BetPriceDropdown price={formatPrice((averageUnder))} />
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>
										<div style={{ backgroundColor: '#363844', padding: '6px', borderRadius: '4px', width: '48px', color: '#eff1f5', textAlign: 'center', fontSize: '12px' }}>HIGH</div>
									</TableCell>
									<TableCell>
										<BetPriceDropdown price={formatPrice((highOver))} />
									</TableCell>
									<TableCell>
										<BetPriceDropdown price={formatPrice((highUnder))} />
									</TableCell>
								</TableRow>
								{sortByPropertyMatch(
									sortByNumberMatch(relatedOddsAndCustomDeduped, isOver ? 'bet_price_over' : 'bet_price_under', isOver ? highOver : highUnder),
									'sportsbook',
									sportsbooksToHighlight
								)
									.sort((a, b) => {
										// Priority 1: "WagerWiz" goes to the top
										if (a.sportsbook === 'WagerWiz') return -1;
										if (b.sportsbook === 'WagerWiz') return 1;

										// Priority 2: Highlighted sportsbook goes next
										const highlighted = sportsbooksToHighlight[sportsbooksToHighlight.length - 1];
										if (a.sportsbook === highlighted) return -1;
										if (b.sportsbook === highlighted) return 1;

										// Priority 3: Alphabetical order
										return a.sportsbook.localeCompare(b.sportsbook);
									})
									.map((relatedRow, index) => {
										//
										let style = {
											borderRadius: 8,
										};
										let sportsbook_name = relatedRow.sportsbook;

										if (sportsbook_dumb === relatedRow.sportsbook) {
											style.border = '2px solid #1e6ffc';
											style.backgroundColor = '#22262e';
										} else if (relatedRow.sportsbook === 'WagerWiz') {
											style.border = '2px solid #1e6ffc';
											style.backgroundColor = '#22262e';
										}

										if (additionalSportsbooksToHighlight.includes(relatedRow.sportsbook)) {
											style.border = '2px solid #1e6ffc';
											style.backgroundColor = '#22262e';
										}

										return (
											<TableRow
												style={style}
												className="cursor-pointer"
												onClick={() => {
													if (additionalSportsbooksToHighlight.includes(relatedRow.sportsbook)) {
														setAdditionalSportsbooksToHighlight(additionalSportsbooksToHighlight.filter((e) => e !== relatedRow.sportsbook));
													} else {
														setAdditionalSportsbooksToHighlight([...new Set([...additionalSportsbooksToHighlight, relatedRow.sportsbook])]);
													}
												}}>
												<TableCell>
													<LogoGenerator sportsbook={sportsbook_name} />
												</TableCell>
												<TableCell>
													<BetPriceDropdown
										price={index === 0 && relatedRow.sportsbook === 'WagerWiz' ? pickPrice(relatedRow, overSide, isSpread) : formatPrice(pickPrice(relatedRow, overSide, isSpread))}
													/>
												</TableCell>
												<TableCell>
												<BetPriceDropdown
													price={(function(){
														if (isSpreadMarket) {
															// First try relatedOdds with underSide key (the other team's price may already be in the same row)
															const directVal = pickPrice(relatedRow, underSide, true);
															if (directVal != null) {
																return index === 0 && relatedRow.sportsbook === 'WagerWiz' ? directVal : formatPrice(directVal);
															}
															// Fall back to otherSideRelatedOdds
															const leftBook = normalizeSportsbookName(relatedRow?.sportsbook);
															const match = otherSideRelatedOdds?.find((r) => normalizeSportsbookName(r?.sportsbook) === leftBook);
															if (match) {
																const val = pickPrice(match, rightColumnKey, true);
																if (val != null) {
																	return index === 0 && relatedRow.sportsbook === 'WagerWiz' ? val : formatPrice(val);
																}
															}
															return null;
														}
														return index === 0 && relatedRow.sportsbook === 'WagerWiz' ? pickPrice(relatedRow, rightColumnKey, false) : formatPrice(pickPrice(relatedRow, rightColumnKey, false));
													})()}
												/>
												</TableCell>
											</TableRow>
										);
									})}
							</TableBody>
						</Table>
					</div>
				</div>
				<Modal
					open={isModalOpen}
					onClose={() => {
						setIsModalOpen(false);
					}}>
					<Box
						sx={{
							position: 'absolute',
							top: '50%',
							left: '50%',
							transform: 'translate(-50%, -50%) scale(0.9)',
							width: '90vw',
							height: '90vh',
							bgcolor: '#24262c',
							boxShadow: 24,
							p: 1.4,
							borderRadius: 2,
							overflow: 'auto',
						}}>
						{/* Over/Under slider at top center */}
						<div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
							<div style={{ display: 'flex', backgroundColor: '#17191d', borderRadius: '6px', padding: '2px' }}>
								<button
									onClick={() => setSelectedSide('over')}
									style={{
										backgroundColor: selectedSide === 'over' ? '#1e6ffc' : 'transparent',
										color: selectedSide === 'over' ? '#ffffff' : '#b1b6c1',
										border: 'none',
										padding: '8px 16px',
										borderRadius: '4px',
										cursor: 'pointer',
										fontSize: '12px',
										fontWeight: '500',
										transition: 'all 0.2s ease'
									}}
								>
									{(outcomesplit[1] === 'Point Spread' || outcomesplit[1] === 'Asian Handicap') ? spreadPhrase : (outcomesplit[1] === 'Moneyline' ? moneylineTeamOver : 'OVER')}
								</button>
								<button
									onClick={() => setSelectedSide('under')}
									style={{
										backgroundColor: selectedSide === 'under' ? '#1e6ffc' : 'transparent',
										color: selectedSide === 'under' ? '#ffffff' : '#b1b6c1',
										border: 'none',
										padding: '8px 16px',
										borderRadius: '4px',
										cursor: 'pointer',
										fontSize: '12px',
										fontWeight: '500',
										transition: 'all 0.2s ease'
									}}
								>
									{(outcomesplit[1] === 'Point Spread' || outcomesplit[1] === 'Asian Handicap') ? spreadPhraseUnder : (outcomesplit[1] === 'Moneyline' ? moneylineTeamUnder : 'UNDER')}
								</button>
							</div>
						</div>
						<OddsHistoryGraph
							oddsHistories={oddsHistories}
							split={outcomesplit}
							additionalSportsbooksToHighlight={additionalSportsbooksToHighlight}
							sportsbooksToHighlight={sportsbooksToHighlight}
							setAdditionalSportsbooksToHighlight={setAdditionalSportsbooksToHighlight}
							showLogo={false}
							sharpFilter={sharpFilter}
							sharpBook={sharpBook}
							timeRange={selected}
							isMobile={true}
							setIsModalOpen={setIsModalOpen}
							isModalOpen={isModalOpen}
							selected={selected}
							setSelected={setSelected}
							overSide={overSide}
							underSide={underSide}
							tutorial={tutorial}
							spreadPhrase={spreadPhraseUnder}
							selectedSide={selectedSide}
							points={(() => {
								const pointsValue = selectedRow?.points;
								if (!pointsValue && selectedRow) {
									console.log('[DEBUG] selectedRow points is undefined. selectedRow:', selectedRow);
								}
								return pointsValue;
							})()}
						/>
					</Box>
				</Modal>
			</div>
		);
	}
};
